/**
 * Created by Jie Gao on 2017-05-24.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Timeline, TimelineLite} from "gsap";
import {WixxReelSymbol} from "../../reelsymbol/WixxReelSymbol";
import {WixxParsedGameData} from "../../server/data/WixxParsedGameData";
import {WixxHelper} from "../../utils/WixxHelper";
import {Wixx} from "../../Wixx";
import {WixxGameConfig} from "../../WixxGameConfig";
import {WixxSoundConfig} from "../../WixxSoundConfig";
import {WixxWinPresentationEvent} from "../event/WixxWinPresentationEvent";
import {WinWaysWonIndicator} from "../winwayswon/WinWaysWonIndicator";
import {WixxBigWinView} from "./WixxBigWinView";

export class WixxBigWinController extends StepCountUpBigWinController {

    private _currentLineIndex:number;
    private _winSymbols:StateReelSymbol[];
    private _wixxGameData:WixxParsedGameData;

    private _winSounds:string[];
    private _wixxView:WixxBigWinView;
    private _timelineSymbolAnimation:TimelineLite | null;

    constructor(indexes:[number, number]) {
        super(indexes, {
            skipLastLevelCountUpIfSmall : true,
            skippableOnEachLevel : false
        });

        this._winSounds = [
            WixxSoundConfig.instance.WIN_BIG_BIG,
            WixxSoundConfig.instance.WIN_BIG_MEGA,
            WixxSoundConfig.instance.WIN_BIG_SUPER_MEGA,
            WixxSoundConfig.instance.WIN_BIG_EXTREME
        ];
        this._currentLineIndex = -1;
        this._winSymbols = [];
        this._wixxView = new WixxBigWinView();
    }

    protected parseFeatureGameData(data:WixxParsedGameData):void {
        super.parseFeatureGameData(data);
        this._wixxGameData = data;
    }

    protected startWinPresentation():void {
        super.startWinPresentation();

        // Logger.logDev(`BigWin.startWinPresentation._winSymbols.length = ${this._winSymbols.length}`);
        EventHandler.dispatchEvent(new GameEvent(WinWaysWonIndicator.SHOW_WIN_WAYS_WON));
        this._wixxView.startPresentation(this._gameData!.singleWin, this._winLevel, this._wixxGameData.mode);
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        return this._wixxView.getWinLevelAnimation(level);
    }

    protected playBigWinSound():void {
        if(WixxSoundConfig.instance.WIN_BIG_MUSIC != null) {
            SlotGame.sound.playAmbience(WixxSoundConfig.instance.WIN_BIG_MUSIC);
        }
    }

    protected playBigWinLevelSound(level:number):void {
        if(this._winSounds[level] != null) {
            SlotGame.sound.playEffect(this._winSounds[level]);
        }
    }

    protected playBigWinCountUpSound(level:number):void {
        if(WixxSoundConfig.instance.COUNT_UP_BIG != null) {
            SlotGame.sound.stopEffect(WixxSoundConfig.instance.COUNT_UP_BIG);
            SlotGame.sound.playEffect(WixxSoundConfig.instance.COUNT_UP_BIG);
        }
    }

    protected playSymbolsAnimation():void {
        if(this.playAllNoWinSymbols) {
            this.playAllNoWinSymbols();
        }
        this.playNextBetWinPresentation();
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin?:number):gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax | null {
        return Wixx.winCountUp.getCountUpAnimation(from, to, duration);
    }

    private playAllNoWinSymbols():void {
        const reelsNum:number = WixxGameConfig.instance.REELS_NUM;
        const symbolsNum:number = WixxGameConfig.instance.SYMBOLS_NUM_IN_REEL[2];
        const symbolWinStates = ArrayHelper.initArrayWithValues<boolean[]>(reelsNum, () => {
            return ArrayHelper.initArrayWithValues<boolean>(symbolsNum, () => {return false;})
        });

        for(let l:number = 0; l < this._betWinsData!.length; l++) {
            const betWayWinData:IBetWayWinData = <IBetWayWinData>this._betWinsData![l];
            for(let i:number = 0; i < betWayWinData.reelWinPositions.length; i++) {
                for(let j:number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                    if(betWayWinData.reelWinPositions[i][j]) {
                        symbolWinStates[i][j] = true;
                    }
                }
            }
        }

        let noWinSymbol:StateReelSymbol | null;
        for(let i:number = 0; i < symbolWinStates.length; i++) {
            for(let j:number = 0; j < symbolWinStates[i].length; j++) {
                if(symbolWinStates[i][j]) {
                    continue;
                }

                noWinSymbol = Reels.getSymbol(i, j);
                if(noWinSymbol == null) {
                    continue;
                }

                noWinSymbol.changeState({
                    state : WixxGameConfig.instance.SYMBOL_STATES.noWin!,
                    fadeInDuration : 1.5
                });
            }
        }
    }

    private playNextBetWinPresentation():void {
        if(this._betWinsData === null) {
            return;
        }
        this.resetWinSymbols();

        // play next line
        this._currentLineIndex++;
        if(this._currentLineIndex >= this._betWinsData!.length) {
            this._currentLineIndex = 0;
        }

        const timeline = new TimelineLite({paused : true, onComplete : () => this.playNextBetWinPresentation()});
        // Add 0.1 time offset here to make sure the resetWinSymbols have time to finish.
        timeline.add(this.getLineAnimation(<IBetWayWinData>this._betWinsData![this._currentLineIndex]), 0.1);

        if(this._timelineSymbolAnimation && this._timelineSymbolAnimation.isActive()) {
            this._timelineSymbolAnimation.pause();
            this._timelineSymbolAnimation.kill();
        }
        this._timelineSymbolAnimation = timeline;
        this._timelineSymbolAnimation.play();
    }

    private getLineAnimation(betWayWinData:IBetWayWinData):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        const reelsNum:number = betWayWinData.length;
        let currentDuration:number = 0;
        for(let i:number = 0; i < reelsNum; i++) {
            for(let j:number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                if(betWayWinData.reelWinPositions[i][j]) {
                    const symbol = Reels.getSymbol(i, j);
                    if(symbol) {
                        this.addSymbolWinAnimationToTimeline(betWayWinData, timeline, 0, <WixxReelSymbol>symbol);
                        this._winSymbols.push(symbol);
                    }
                }
            }
            currentDuration = timeline.totalDuration();
        }

        return timeline;
    }

    private addSymbolWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number, symbol:WixxReelSymbol):void {
        timeline.add(symbol.changeState({
            state : WixxGameConfig.instance.SYMBOL_STATES.win,
            fadeInDuration : 0.4
        }), startTime);

        if(this._wixxGameData.multiplierRespinActive) {
            if((this._wixxGameData.symbolToWildRespinActive && symbol.symName.indexOf("M1") > -1) || symbol.symName === ReelSymbolName.WILD) {
                if(WixxHelper.isMidSymbol(betWayWinData.symbol)) {
                    timeline.add(symbol.playMultiplier(), startTime);
                } else {
                    timeline.add(() => symbol.hideMultiplier(0), startTime);
                }
            }
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        this._wixxView.stopWinPresentation(isAborted);
        EventHandler.dispatchEvent(new GameEvent(WinWaysWonIndicator.SHOW_WIN_WAYS_WON));

        super.stopWinPresentation(isAborted);

        EventHandler.dispatchEvent(new GameEvent(WixxWinPresentationEvent.BIG_WIN_PRESENTATIONS_STOPPED));
    }

    protected stopSymbolsAnimation():void {
        // Logger.logDev(`bigwin.stopSymbolsAnimation`);
        if(this._timelineSymbolAnimation) {
            if(this._timelineSymbolAnimation.isActive()) {
                this._timelineSymbolAnimation.pause();
                this._timelineSymbolAnimation.kill();
            }
            this._timelineSymbolAnimation = null;
        }
        this._currentLineIndex = -1;
        this.resetWinSymbols();
    }

    private resetWinSymbols():void {
        // Logger.logDev(`BigWin.resetWinSymbols.winSymbol.length = ${this._winSymbols.length}`);
        while(this._winSymbols.length > 0) {
            this._winSymbols.pop()!.changeState({
                state : WixxGameConfig.instance.SYMBOL_STATES.win,
                frames : [-1, -1]
            });
        }
        Logger.logDev(`BigWin.After resetWinSymbols.winSymbol.length = ${this._winSymbols.length}`);
    }

    protected stopAllSounds():void {
        const sounds = this._winSounds;
        if(sounds) {
            for(let i = 0; i < sounds.length; i++) {
                if(sounds[i]) {
                    SlotGame.sound.stopEffect(sounds[i]);
                }
            }
        }
        if(WixxSoundConfig.instance.COUNT_UP_BIG != null) {
            SlotGame.sound.stopEffect(WixxSoundConfig.instance.COUNT_UP_BIG);
        }
        if(WixxSoundConfig.instance.MAIN_GAME_AMBIANCE != null) {
            SlotGame.sound.playAmbience(WixxSoundConfig.instance.MAIN_GAME_AMBIANCE);
        }
    }

    protected playEndingAnimation(isAborted:boolean):void {
        this._wixxView.playEndAnimation(isAborted);
        Wixx.winCountUp.getEndingAnimation(this._wixxGameData.singleWin);
        SlotGame.winFieldController.showWinField(this._gameData!.totalWin);
        if(WixxSoundConfig.instance.WIN_BIG_MUSIC_END != null) {
            SlotGame.sound.playEffect(WixxSoundConfig.instance.WIN_BIG_MUSIC_END);
        }
    }

    protected resetFeature():void {
        this._winLevel = -1;
        this._wixxView.resetFeature();
    }
}
